import { strCode } from "../consts";

const tableDataStatuses = {
  active: {
    id: "active",
    title: strCode.ACTIVE_FILTER_BTN
  },
  inactive: {
    id: "inactive",
    title: strCode.INACTIVE_FILTER_BTN
  },
  draft: {
    id: "draft",
    title: strCode.DRAFT_BTN
  }
};

export default tableDataStatuses;
